import React from 'react';
import { Flex } from '../Flex';
import { Label } from './components/Label';
import dogAgeIcon from './assets/icon-dog-age.svg';
import dogBreedIcon from './assets/icon-dog-breed.svg';
import dogNameIcon from './assets/icon-dog-name.svg';
import thumbsUpIcon from './assets/icon-thumbs-up.svg';
import { LikeLabel } from './components/LikeLabel';
import { Box } from '../../wag-react/next-components/box';
export type ArticleAdviceCardHeaderValue = Record<'name' | 'breed' | 'ageLabel' | 'upvoteApiUrl' | 'downvoteApiUrl', string> & {
  numberOfVotes: number;
};
type Props = {
  value: ArticleAdviceCardHeaderValue;
};
export const ArticleAdviceCardHeader = ({
  value: {
    name,
    breed,
    ageLabel,
    numberOfVotes
  }
}: Props) => <Flex py={['16px', '24px']} px={['16px', '24px']} backgroundColor="#F5F5F5" width={1} alignItems="flex-end" data-sentry-element="Flex" data-sentry-component="ArticleAdviceCardHeader" data-sentry-source-file="index.tsx">
    <Flex flex="1" flexDirection={['column', 'row']} justifyContent="flex-start" alignItems={['flex-start', 'center', 'center']} gridGap={['12px', '24px']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">

      <Label src={dogBreedIcon} flexDirection="row" value={breed} alt="dog-breed-icon" textProps={{
      ml: '5px',
      color: '#4B7C68',
      fontFamily: 'muliBold',
      fontWeight: 'bold'
    }} data-sentry-element="Label" data-sentry-source-file="index.tsx" />
      <Label display={name ? 'flex' : 'none'} src={dogNameIcon} value={name} alt="dog-name-icon" flexDirection="row" textProps={{
      ml: '5px',
      color: '#4B7C68',
      fontFamily: 'muliBold',
      fontWeight: 'bold'
    }} data-sentry-element="Label" data-sentry-source-file="index.tsx" />
      <Label src={dogAgeIcon} flexDirection="row" value={ageLabel} alt="dog-age-icon" textProps={{
      ml: '5px',
      color: '#4B7C68',
      fontFamily: 'muliBold',
      fontWeight: 'bold'
    }} data-sentry-element="Label" data-sentry-source-file="index.tsx" />

      <LikeLabel display={['none', 'flex']} src={thumbsUpIcon} flexDirection="row" value={numberOfVotes} alt="thumbs-up-icon" textProps={{
      ml: '5px',
      color: '#4B7C68',
      fontFamily: 'muliBold',
      fontWeight: 'bold'
    }} ml="auto" data-sentry-element="LikeLabel" data-sentry-source-file="index.tsx" />
    </Flex>

    <Box data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <LikeLabel display={['flex', 'none']} src={thumbsUpIcon} flexDirection="row" value={numberOfVotes} alt="thumbs-up-icon" textProps={{
      ml: '5px',
      color: '#4B7C68',
      fontFamily: 'muliBold',
      fontWeight: 'bold'
    }} ml="auto" data-sentry-element="LikeLabel" data-sentry-source-file="index.tsx" />
    </Box>
  </Flex>;
export type ArticleAdviceCardHeaderProps = Props;